// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"810decb0","725":"64eaa5e7","953":"03074068","975":"2fbd1006"}[chunkId] + ".chunk.js";
};